import React from 'react';
import { FiArrowLeft, FiCompass } from 'react-icons/fi';
import Footer from '../components/Footer';
import Header from '../components/Header';
import SEO from '../components/SEO';

export default function NotFoundPage() {
  return (
    <div className="page-shell min-h-screen">
      <SEO
        title="Page not found | LSA Bill"
        description="The page you are looking for could not be found."
        canonicalUrl="https://lsabill.net/404/"
        ogTitle="Page not found | LSA Bill"
        ogDescription="The page you are looking for could not be found."
        ogUrl="https://lsabill.net/404/"
        ogImage="https://lsabill.net/logo.webp"
        schema={{ '@context': 'https://schema.org', '@type': 'WebPage', name: 'Page not found' }}
      />
      <Header />

      <main className="flex min-h-[calc(100vh-15rem)] items-center px-4 py-10 sm:px-6 lg:px-8">
        <section className="mx-auto w-full max-w-2xl overflow-hidden rounded-[36px] border border-[var(--line-soft)] bg-white/82 text-center shadow-[var(--shadow-soft)] backdrop-blur-xl">
          <div className="bg-[radial-gradient(circle_at_top,rgba(139,189,195,0.3),transparent_42%),linear-gradient(180deg,rgba(255,255,255,0.9),rgba(237,243,248,0.96))] px-6 py-14 sm:px-12 sm:py-20">
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[var(--brand-accent)] text-white shadow-lg shadow-[rgba(31,111,120,0.2)]">
              <FiCompass className="h-7 w-7" aria-hidden="true" focusable="false" />
            </div>
            <p className="mt-7 text-sm font-bold uppercase tracking-[0.2em] text-[var(--brand-accent)]">Error 404</p>
            <h1 className="mt-3 text-4xl font-bold leading-tight text-[var(--brand-ink)] sm:text-5xl">This page has wandered off.</h1>
            <p className="mx-auto mt-5 max-w-lg text-base leading-7 text-[var(--text-muted)]">The link may be incorrect or the page may no longer be available. Let’s get you back to the support portal.</p>
            <a href="/" className="mt-8 inline-flex items-center gap-2 rounded-full bg-[var(--brand-ink)] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[var(--brand-accent)]">
              <FiArrowLeft className="h-4 w-4" aria-hidden="true" focusable="false" />
              Return to home
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
